/**
 * The required files for cost-to-serve analysis that the user must provide in step one of configuration.
 */
export const c2sFileMap = {
  ArtifactFiles: [
    {
      id: "layersConfiguration",
      title: "Layers Configuration",
      file: "layers_configuration.json",
    },
    {
      id: "bom",
      title: "Bill of Materials",
      file: "bom.csv",
    },
    {
      id: "costBreakdown",
      title: "Cost Breakdown",
      file: "cost_breakdown.csv",
    },
  ],
} as const;
